import { create } from "zustand";
import { MenuDrawerStore } from "./types";

export const useMenuDrawerStore = create<MenuDrawerStore>()((set) => ({
  isMenuDrawerOpen: false,
  setIsMenuDrawerOpen: (isMenuDrawerOpen: boolean) => set({ isMenuDrawerOpen }),
}));
